import Vue from 'vue';
import layout from './layout/layout';
import loading from './loading';
import icon from './ui/icon';
import card from './ui/card';
import missing from './ui/missing';
import dismiss from './ui/dismiss';
import dropdown from './ui/dropdown';
import drawer from './ui/drawer';
import textInput from './ui/inputs/text-input';
import selectInput from './ui/inputs/select-input';
import sortLink from './ui/sort-link';
import sortedTable from './ui/sorted-table';


export default {
  register() {
    Vue.component(`c-${layout.name}`, layout);
    Vue.component(`c-${loading.name}`, loading);
    Vue.component(`c-${icon.name}`, icon);
    Vue.component(`c-${card.name}`, card);
    Vue.component(`c-${missing.name}`, missing);
    Vue.component(`c-${dismiss.name}`, dismiss);
    Vue.component(`c-${dropdown.name}`, dropdown);
    Vue.component(`c-${drawer.name}`, drawer);
    Vue.component(`c-${textInput.name}`, textInput);
    Vue.component(`c-${selectInput.name}`, selectInput);
    Vue.component(`c-${sortLink.name}`, sortLink);
    Vue.component(`c-${sortedTable.name}`, sortedTable);
  }
};
